export default "__VITE_ASSET__BzKrVbFI__"